// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GraphqlTag from "graphql-tag";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as Trophy$LiteracyplanetClientSxEntry from "../Trophy.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as AcademyFragments$LiteracyplanetClientSxEntry from "./AcademyFragments.res.mjs";
import * as AcademyParallaxTypes$LiteracyplanetClientSxEntry from "./AcademyParallaxTypes.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query AcademyMatrixAggregatesQuery($params: AcademyMatrixInput!)  {\nacademyMatrixAggregates(params: $params)  {\n...AcademyMatrixAggregateFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixAggregateFragment.query);

function parse(value) {
  var value$1 = value.academyMatrixAggregates;
  return {
          academyMatrixAggregates: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixAggregateFragment.verifyArgsAndParse("AcademyMatrixAggregateFragment", value);
              })
        };
}

function serialize(value) {
  var value$1 = value.academyMatrixAggregates;
  var academyMatrixAggregates = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixAggregateFragment.serialize(value);
      });
  return {
          academyMatrixAggregates: academyMatrixAggregates
        };
}

function serializeInputObjectAcademyMatrixInput(inp) {
  var a = inp.name;
  var a$1 = inp.md5;
  var a$2 = inp.accuracyKind;
  var a$3 = inp.locale;
  var a$4 = inp.blacklists;
  var a$5 = inp.classId;
  var a$6 = inp.startDate;
  var a$7 = inp.endDate;
  var a$8 = inp.limit;
  var a$9 = inp.offset;
  var a$10 = inp.mode;
  return {
          name: a !== undefined ? a : undefined,
          md5: a$1 !== undefined ? a$1 : undefined,
          categoryId: inp.categoryId,
          accuracyKind: a$2 === "question" ? "question" : "response",
          userId: inp.userId,
          locale: a$3 === "en_BZ" ? "en_BZ" : (
              a$3 === "en_CA" ? "en_CA" : (
                  a$3 === "en_CB" ? "en_CB" : (
                      a$3 === "en_GB" ? "en_GB" : (
                          a$3 === "en_IE" ? "en_IE" : (
                              a$3 === "en_IN" ? "en_IN" : (
                                  a$3 === "en_JM" ? "en_JM" : (
                                      a$3 === "en_NZ" ? "en_NZ" : (
                                          a$3 === "en_PH" ? "en_PH" : (
                                              a$3 === "en_TT" ? "en_TT" : (
                                                  a$3 === "en_US" ? "en_US" : (
                                                      a$3 === "en_ZA" ? "en_ZA" : (
                                                          a$3 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          blacklists: a$4.map(function (b) {
                return b;
              }),
          classId: a$5 !== undefined ? a$5 : undefined,
          startDate: a$6 !== undefined ? a$6 : undefined,
          endDate: a$7 !== undefined ? a$7 : undefined,
          limit: a$8 !== undefined ? a$8 : undefined,
          offset: a$9 !== undefined ? a$9 : undefined,
          mode: a$10 === "lp" ? "lp" : (
              a$10 === "admin" ? "admin" : (
                  a$10 === "student" ? "student" : "teacher"
                )
            )
        };
}

function serializeVariables(inp) {
  return {
          params: serializeInputObjectAcademyMatrixInput(inp.params)
        };
}

function makeVariables(params, param) {
  return {
          params: params
        };
}

function makeInputObjectAcademyMatrixInput(name, md5, categoryId, accuracyKind, userId, locale, blacklists, classId, startDate, endDate, limit, offset, mode, param) {
  return {
          name: name,
          md5: md5,
          categoryId: categoryId,
          accuracyKind: accuracyKind,
          userId: userId,
          locale: locale,
          blacklists: blacklists,
          classId: classId,
          startDate: startDate,
          endDate: endDate,
          limit: limit,
          offset: offset,
          mode: mode
        };
}

var AcademyMatrixAggregatesQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectAcademyMatrixInput: serializeInputObjectAcademyMatrixInput,
  makeVariables: makeVariables,
  makeInputObjectAcademyMatrixInput: makeInputObjectAcademyMatrixInput
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var AcademyMatrixAggregatesQuery = {
  AcademyMatrixAggregatesQuery_inner: AcademyMatrixAggregatesQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectAcademyMatrixInput: serializeInputObjectAcademyMatrixInput,
  makeVariables: makeVariables,
  makeInputObjectAcademyMatrixInput: makeInputObjectAcademyMatrixInput,
  use: use,
  useFetch: useFetch
};

var AcademyMatrixAggregates = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

var Raw$1 = {};

var query$1 = GraphqlTag.gql([
      "query AcademyActivitiesQuery($params: AcademyMatrixInput!)  {\nacademyMatrixActivities(params: $params)  {\n...AcademyMatrixActivityFragment   \n}\n\n}\n",
      ""
    ], AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixActivityFragment.query);

function parse$1(value) {
  var value$1 = value.academyMatrixActivities;
  return {
          academyMatrixActivities: value$1.map(function (value) {
                return AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixActivityFragment.verifyArgsAndParse("AcademyMatrixActivityFragment", value);
              })
        };
}

function serialize$1(value) {
  var value$1 = value.academyMatrixActivities;
  var academyMatrixActivities = value$1.map(function (value) {
        return AcademyFragments$LiteracyplanetClientSxEntry.AcademyMatrixActivityFragment.serialize(value);
      });
  return {
          academyMatrixActivities: academyMatrixActivities
        };
}

function serializeInputObjectAcademyMatrixInput$1(inp) {
  var a = inp.name;
  var a$1 = inp.md5;
  var a$2 = inp.accuracyKind;
  var a$3 = inp.locale;
  var a$4 = inp.blacklists;
  var a$5 = inp.classId;
  var a$6 = inp.startDate;
  var a$7 = inp.endDate;
  var a$8 = inp.limit;
  var a$9 = inp.offset;
  var a$10 = inp.mode;
  return {
          name: a !== undefined ? a : undefined,
          md5: a$1 !== undefined ? a$1 : undefined,
          categoryId: inp.categoryId,
          accuracyKind: a$2 === "question" ? "question" : "response",
          userId: inp.userId,
          locale: a$3 === "en_BZ" ? "en_BZ" : (
              a$3 === "en_CA" ? "en_CA" : (
                  a$3 === "en_CB" ? "en_CB" : (
                      a$3 === "en_GB" ? "en_GB" : (
                          a$3 === "en_IE" ? "en_IE" : (
                              a$3 === "en_IN" ? "en_IN" : (
                                  a$3 === "en_JM" ? "en_JM" : (
                                      a$3 === "en_NZ" ? "en_NZ" : (
                                          a$3 === "en_PH" ? "en_PH" : (
                                              a$3 === "en_TT" ? "en_TT" : (
                                                  a$3 === "en_US" ? "en_US" : (
                                                      a$3 === "en_ZA" ? "en_ZA" : (
                                                          a$3 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          blacklists: a$4.map(function (b) {
                return b;
              }),
          classId: a$5 !== undefined ? a$5 : undefined,
          startDate: a$6 !== undefined ? a$6 : undefined,
          endDate: a$7 !== undefined ? a$7 : undefined,
          limit: a$8 !== undefined ? a$8 : undefined,
          offset: a$9 !== undefined ? a$9 : undefined,
          mode: a$10 === "lp" ? "lp" : (
              a$10 === "admin" ? "admin" : (
                  a$10 === "student" ? "student" : "teacher"
                )
            )
        };
}

function serializeVariables$1(inp) {
  return {
          params: serializeInputObjectAcademyMatrixInput$1(inp.params)
        };
}

function makeVariables$1(params, param) {
  return {
          params: params
        };
}

function makeInputObjectAcademyMatrixInput$1(name, md5, categoryId, accuracyKind, userId, locale, blacklists, classId, startDate, endDate, limit, offset, mode, param) {
  return {
          name: name,
          md5: md5,
          categoryId: categoryId,
          accuracyKind: accuracyKind,
          userId: userId,
          locale: locale,
          blacklists: blacklists,
          classId: classId,
          startDate: startDate,
          endDate: endDate,
          limit: limit,
          offset: offset,
          mode: mode
        };
}

var AcademyMatrixActivitiesQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectAcademyMatrixInput: serializeInputObjectAcademyMatrixInput$1,
  makeVariables: makeVariables$1,
  makeInputObjectAcademyMatrixInput: makeInputObjectAcademyMatrixInput$1
};

var include$1 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var useFetch$1 = include$1.useFetch;

var AcademyMatrixActivitiesQuery = {
  AcademyMatrixActivitiesQuery_inner: AcademyMatrixActivitiesQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectAcademyMatrixInput: serializeInputObjectAcademyMatrixInput$1,
  makeVariables: makeVariables$1,
  makeInputObjectAcademyMatrixInput: makeInputObjectAcademyMatrixInput$1,
  use: use$1,
  useFetch: useFetch$1
};

var AcademyMatrixActivities = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1,
      useFetch: useFetch$1
    });

function useActivities(userId) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  var $$fetch = AcademyMatrixActivities.useAsync();
  var makeScore = function (accuracy) {
    return Belt_Option.map(accuracy, (function (accuracy) {
                  return {
                          accuracy: accuracy,
                          trophy: Trophy$LiteracyplanetClientSxEntry.scoreToTrophy(accuracy)
                        };
                }));
  };
  return async function (startDateOpt, startDateOpt$1, endDateOpt, limitOpt, offsetOpt, classIdOpt, blacklistsOpt, accuracyKindOpt, modeOpt, md5Opt, nameOpt, categoryId) {
    var startDate = startDateOpt$1 !== undefined ? Caml_option.valFromOption(startDateOpt$1) : undefined;
    var endDate = endDateOpt !== undefined ? Caml_option.valFromOption(endDateOpt) : undefined;
    var limit = limitOpt !== undefined ? Caml_option.valFromOption(limitOpt) : undefined;
    var offset = offsetOpt !== undefined ? Caml_option.valFromOption(offsetOpt) : undefined;
    var classId = classIdOpt !== undefined ? Caml_option.valFromOption(classIdOpt) : undefined;
    var blacklists = blacklistsOpt !== undefined ? blacklistsOpt : [];
    var accuracyKind = accuracyKindOpt !== undefined ? accuracyKindOpt : "response";
    var mode = modeOpt !== undefined ? modeOpt : "student";
    var md5 = md5Opt !== undefined ? Caml_option.valFromOption(md5Opt) : undefined;
    var name = nameOpt !== undefined ? Caml_option.valFromOption(nameOpt) : undefined;
    return Belt_Option.map(await $$fetch({
                    params: {
                      name: name,
                      md5: md5,
                      categoryId: categoryId,
                      accuracyKind: accuracyKind,
                      userId: userId,
                      locale: locale,
                      blacklists: blacklists,
                      classId: classId,
                      startDate: startDate,
                      endDate: endDate,
                      limit: limit,
                      offset: offset,
                      mode: mode
                    }
                  }), (function (q) {
                  return Belt_Array.reduce(q.academyMatrixActivities, undefined, (function (m, r) {
                                return Belt_Array.reduce(r.activities, m, (function (m, a) {
                                              return Belt_MapString.set(m, AcademyParallaxTypes$LiteracyplanetClientSxEntry.makeMatrixKey(r.studentId, a.id), {
                                                          TAG: "ActivityAgg",
                                                          _0: {
                                                            contentId: a.contentId,
                                                            kind: a.kind,
                                                            contentKind: a.contentKind,
                                                            bestAttempt: makeScore(a.bestAttempt),
                                                            latestAttempt: makeScore(a.latestAttempt),
                                                            attempts: a.attempts,
                                                            progressState: Belt_Option.isSome(a.started) ? "Started" : (
                                                                Belt_Option.isSome(a.latestAttempt) ? "Finished" : "NotStarted"
                                                              )
                                                          }
                                                        });
                                            }));
                              }));
                }));
  };
}

function useCategories(userId) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  var $$fetch = AcademyMatrixAggregates.useAsync();
  return async function (startDateOpt, startDateOpt$1, endDateOpt, limitOpt, offsetOpt, classIdOpt, blacklistsOpt, accuracyKindOpt, modeOpt, md5Opt, nameOpt, categoryId) {
    var startDate = startDateOpt$1 !== undefined ? Caml_option.valFromOption(startDateOpt$1) : undefined;
    var endDate = endDateOpt !== undefined ? Caml_option.valFromOption(endDateOpt) : undefined;
    var limit = limitOpt !== undefined ? Caml_option.valFromOption(limitOpt) : undefined;
    var offset = offsetOpt !== undefined ? Caml_option.valFromOption(offsetOpt) : undefined;
    var classId = classIdOpt !== undefined ? Caml_option.valFromOption(classIdOpt) : undefined;
    var blacklists = blacklistsOpt !== undefined ? blacklistsOpt : [];
    var accuracyKind = accuracyKindOpt !== undefined ? accuracyKindOpt : "response";
    var mode = modeOpt !== undefined ? modeOpt : "student";
    var md5 = md5Opt !== undefined ? Caml_option.valFromOption(md5Opt) : undefined;
    var name = nameOpt !== undefined ? Caml_option.valFromOption(nameOpt) : undefined;
    return Belt_Option.map(await $$fetch({
                    params: {
                      name: name,
                      md5: md5,
                      categoryId: categoryId,
                      accuracyKind: accuracyKind,
                      userId: userId,
                      locale: locale,
                      blacklists: blacklists,
                      classId: classId,
                      startDate: startDate,
                      endDate: endDate,
                      limit: limit,
                      offset: offset,
                      mode: mode
                    }
                  }), (function (q) {
                  return Belt_Array.reduce(q.academyMatrixAggregates, undefined, (function (m, r) {
                                return Belt_Array.reduce(r.categoryAggregates, m, (function (m, a) {
                                              var uniqueActivityCount = a.uniqueActivityCount;
                                              return Belt_MapString.set(m, AcademyParallaxTypes$LiteracyplanetClientSxEntry.makeMatrixKey(r.studentId, a.categoryId), {
                                                          loading: false,
                                                          avgBestCategoryAttempts: a.avgBestCategoryAttempts,
                                                          avgLatestCategoryAttempts: a.avgLatestCategoryAttempts,
                                                          totalCategoryAttempts: a.totalCategoryAttempts,
                                                          uniqueActivityCount: a.uniqueActivityCount,
                                                          totalActivityCount: a.totalActivityCount,
                                                          progress: uniqueActivityCount !== undefined ? AcademyParallaxTypes$LiteracyplanetClientSxEntry.calcPercent(uniqueActivityCount, a.totalActivityCount) : 0,
                                                          trophy: Belt_Option.map(a.avgLatestCategoryAttempts, Trophy$LiteracyplanetClientSxEntry.scoreToTrophy)
                                                        });
                                            }));
                              }));
                }));
  };
}

var AcademyMatrixAggregateFragment;

var AcademyMatrixActivityFragment;

export {
  AcademyMatrixAggregateFragment ,
  AcademyMatrixAggregatesQuery ,
  AcademyMatrixAggregates ,
  AcademyMatrixActivityFragment ,
  AcademyMatrixActivitiesQuery ,
  AcademyMatrixActivities ,
  useActivities ,
  useCategories ,
}
/* query Not a pure module */
